var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { axiosPrivate } from "../../../api/axios";
const getConfigurableTextSettings = (sku, settingsCallback, errorCallback, loadingCallback) => __awaiter(void 0, void 0, void 0, function* () {
    yield axiosPrivate.get(`/Account/OrderFlowLevelConfigurableTextSettings?sku=${sku}`).then(({ data }) => {
        var _a, _b, _c;
        if ((data === null || data === void 0 ? void 0 : data.success) === false)
            errorCallback("Failed to load the SKU for your order.");
        if (!!data) {
            settingsCallback({
                DeliveryModalDeliveryDescription: (_a = data === null || data === void 0 ? void 0 : data.ConfigurableTextSettings) === null || _a === void 0 ? void 0 : _a.DeliveryModalDeliveryDescription,
                DeliveryModalPickupDescription: (_b = data === null || data === void 0 ? void 0 : data.ConfigurableTextSettings) === null || _b === void 0 ? void 0 : _b.DeliveryModalPickupDescription,
                LoadingText: (_c = data === null || data === void 0 ? void 0 : data.ConfigurableTextSettings) === null || _c === void 0 ? void 0 : _c.LoadingText,
            });
        }
        if (loadingCallback) {
            loadingCallback(false);
        }
    });
});
export const useGetConfigurableTextSettings = (sku) => {
    const [loading, setLoading] = React.useState(false);
    const [configurableTextSettings, setConfigurableTextSettings] = React.useState();
    const [error, setError] = React.useState(undefined);
    React.useEffect(() => {
        if (!!sku) {
            setLoading(true);
            getConfigurableTextSettings(sku, setConfigurableTextSettings, setError, setLoading);
        }
    }, []);
    return { configurableTextSettings, loading, error };
};
